<template>
  <modal name="placeSmartVoice"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
  >
    <div class="cantainer">
      <div class="content">
        <span>
            您希望将这段AI智能配音片段添加到
        </span>
      </div>
      <div class="footer">
        <div class="button button--primary" @click="cancel">当前页面</div>
        <div class="button button--primary" @click="confirm">整个视频</div>
      </div>
      <div class="close-btn" @click="clickToClose()">
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
/**
 * AI语音添加到哪里的对话框
 */
import toAnalysisParams from '@/plugins/toAnalysisParams'

export default {
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    clickToClose () {
      this.$modal.hide('placeSmartVoice');
    },
    beforeOpen ({params} = {}) {

    },
    confirm () {
      this.$bus.emit('placeSmartVoice.goOn');
      this.hide();
      this.$analysis(toAnalysisParams('ai_dub，click_single_insert,AI配音_单页添加'))
    },
    cancel () {
      this.$bus.emit('placeSmartVoice.cancel');
      this.hide();
      this.$analysis(toAnalysisParams('ai_dub，click_global_insert,AI配音_全局添加'))
    },
    hide () {
      this.$modal.hide('placeSmartVoice');
      this.$bus.emit('placeSmartVoice.hide');
    }
  }
}
</script>

<style lang="scss" scoped>
.cantainer {
  position: relative;
  width: 520px;
  height: 220px;
  margin: auto;
  padding-top: 48px;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  margin-bottom: 36px;
  margin-left: 24px;
  margin-right: 24px;
  line-height: 1.8;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  >div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.button {
    width: 160px;
    height: 40px;
    border-radius: 8px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/generateVoice/placeSmartVoice.vue